export default __webpack_public_path__ + "static/media/hero-banner-3.0632af24.jpg";